/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px",
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: 0,
    stt: "",
    asset: "I. Lưu chuyển tiền từ hoạt động kinh doanh",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 1,
    stt: "01",
    asset: "1. Tiền đã chi mua các tài sản chính",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 2,
    stt: "02",
    asset: "2. Tiền đã thu từ bán các tài sản tài chính",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 3,
    stt: "03",
    asset: "3. Tiền chi nộp Quỹ Hỗ trợ thanh toán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 4,
    stt: "04",
    asset: "4. Cổ tức đã nhận",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 5,
    stt: "05",
    asset: "5. Tiền lãi đã thu",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 6,
    stt: "06",
    asset: "6. Tiền chi trả lãi vay cho hoạt động của CTCK",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 7,
    stt: "07",
    asset: "7. Tiền chi trả Tổ chức cung cấp dịch vụ cho CTCK",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 8,
    stt: "08",
    asset: "8. Tiền chi trả cho người lao động",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 9,
    stt: "09",
    asset: "9. Tiền chi nộp thuế liên quan đến hoạt động CTCK",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 10,
    stt: "10",
    asset: "10. Tiền chi thanh toán các chi phí cho hoạt động mua, bán các tài sản chính",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 11,
    stt: "11",
    asset: "11. Tiền thu khác từ hoạt động kinh doanh",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 12,
    stt: "12",
    asset: "12. Tiền chi khác cho hoạt động kinh doanh",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 13,
    stt: "20",
    asset: "Lưu chuyển tiền thuần từ hoạt động kinh doanh",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 14,
    stt: "",
    asset: "II. Lưu chuyển tiền từ hoạt động đầu tư",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 15,
    stt: "21",
    asset: "1. Tiền chi để mua sắm, xây dựng TSCĐ, BĐSĐT và các tài sản khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 16,
    stt: "22",
    asset: "2. Tiền thu từ thanh lý, nhượng bán TSCĐ, BĐSĐT và các tài sản khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  // {
  //   id: 17,
  //   stt: "23",
  //   asset:
  //     "3. Tiền chi đầu tư góp vốn vào công ty con, công ty liên doanh, liên kết và đầu tư khác",
  //   assetBold: false,
  //   sttBold: false,
  //   presentBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   presentReadOnly: false,
  //   value: { present: "", now: 0, before: 0 },
  // },
  // {
  //   id: 18,
  //   stt: "24",
  //   asset:
  //     "4. Tiền thu hồi đầu tư góp vốn vào công ty con, công ty liên doanh, liên kết và đầu tư khác",
  //   assetBold: false,
  //   sttBold: false,
  //   presentBold: false,
  //   readOnly: false,
  //   valueBold: false,
  //   presentReadOnly: false,
  //   value: { present: "", now: 0, before: 0 },
  // },
  {
    id: 19,
    stt: "25",
    asset: "3. Tiền thu về cổ tức và lợi nhuận được chia từ các khoản đầu tư tài chính dài hạn",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 20,
    stt: "30",
    asset: "Lưu chuyển tiền thuần từ hoạt động đầu tư",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 21,
    stt: "",
    asset: "III. Lưu chuyển tiền từ hoạt động tài chính",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 22,
    stt: "31",
    asset: "1. Tiền thu từ phát hành cổ phiếu, nhận vốn góp của chủ sở hữu",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 23,
    stt: "32",
    asset: "2. Tiền chi trả vốn góp cho các chủ sở hữu, mua lại cổ phiếu đã phát hành",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 24,
    stt: "33",
    asset: "3. Tiền vay gốc",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 25,
    stt: "33.1",
    asset: "3.1. Tiền vay Quỹ Hỗ trợ thanh toán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 26,
    stt: "33.2",
    asset: "3.2. Tiền vay khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 27,
    stt: "34",
    asset: "4. Tiền chi trả nợ gốc vay",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 28,
    stt: "34.1",
    asset: "4.1. Tiền chi trả gốc vay Quỹ Hỗ trợ thanh toán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 29,
    stt: "34.2",
    asset: "4.2. Tiền chi trả gốc vay tài sản chính",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 30,
    stt: "34.3",
    asset: "4.3. Tiền chi trả gốc vay khác",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 31,
    stt: "35",
    asset: "5. Tiền chi trả nợ gốc thuê tài chính",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 32,
    stt: "36",
    asset: "6. Cổ tức, lợi nhuận đã trả cho chủ sở hữu",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 33,
    stt: "40",
    asset: "Lưu chuyển tiền thuần từ hoạt động tài chính",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 34,
    stt: "50",
    asset: "IV. Tăng/giảm tiền thuần trong kỳ",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 35,
    stt: "60",
    asset: "V. Tiền và các khoản tương đương tiền đầu kỳ",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 36,
    stt: "61",
    asset: "Tiền",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 37,
    stt: "62",
    asset: "Các khoản tương đương tiền",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 38,
    stt: "63",
    asset: "Ảnh hưởng của thay đổi tỷ giá hối đoái quy đổi ngoại tệ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 39,
    stt: "70",
    asset: "VI. Tiền và các khoản tương đương tiền cuối kỳ (70=50+60)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: true,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 40,
    stt: "71",
    asset: "Tiền",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 41,
    stt: "72",
    asset: "Các khoản tương đương tiền",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 42,
    stt: "73",
    asset: "Ảnh hưởng của thay đổi tỷ giá hối đoái quy đổi ngoại tệ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
];
const dataTable2 = [
  {
    id: 0,
    stt: "",
    asset: "I. Lưu chuyển tiền từ hoạt động môi giới, ủy thác của khách hàng",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: "", before: "" },
  },
  {
    id: 1,
    stt: "01",
    asset: "1. Tiền thu bán chứng khoán môi giới cho khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 2,
    stt: "02",
    asset: "2. Tiền chi mua chứng khoán môi giới cho khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 3,
    stt: "03",
    asset: "3. Tiền thu bán chứng khoán ủy thác của khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 4,
    stt: "04",
    asset: "4. Tiền chi mua chứng khoán ủy thác của khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 5,
    stt: "05",
    asset: "5. Thu vay Quỹ Hỗ trợ thanh toán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 6,
    stt: "06",
    asset: "6. Chi trả vay Quỹ Hỗ trợ thanh toán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 7,
    stt: "07",
    asset: "7. Nhận tiền gửi để thanh toán giao dịch chứng khoán của khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 8,
    stt: "08",
    asset: "8. Nhận tiền gửi của Nhà đầu tư cho hoạt động ủy thác đầu tư của khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 9,
    stt: "09",
    asset: "9. Chi trả phí lưu ký chứng khoán của khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 10,
    stt: "10",
    asset: "10. Thu lỗi giao dịch chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 11,
    stt: "11",
    asset: "11. Chi lỗi giao dịch chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 12,
    stt: "12",
    asset: "12. Tiền thu của Tổ chức phát hành chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 13,
    stt: "13",
    asset: "13. Tiền chi trả Tổ chức phát hành chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 14,
    stt: "20",
    asset: "Tăng/giảm tiền thuần trong kỳ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 15,
    stt: "30",
    asset: "II. Tiền và các khoản tương đương tiền đầu kỳ của khách hàng",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 16,
    stt: "31",
    asset: "Tiền gửi ngân hàng đầu kỳ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: true,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 17,
    stt: "32",
    asset:
      "- Tiền gửi của Nhà đầu tư về giao dịch chứng khoán theo phương thức CTCK quản lý. Trong đó có kỳ hạn",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 18,
    stt: "33",
    asset: "- Tiền gửi bù trừ và thanh toán giao dịch chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 19,
    stt: "34",
    asset: "- Tiền gửi tổng hợp giao dịch chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 20,
    stt: "35",
    asset: "- Tiền gửi của tổ chức phát hành. Trong đó có kỳ hạn",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 21,
    stt: "36",
    asset: "Các khoản tương đương tiền",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 22,
    stt: "37",
    asset: "Ảnh hưởng của thay đổi tỷ giá hối đoái quy đổi ngoại tệ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 23,
    stt: "40",
    asset: "III. Tiền và các khoản tương đương tiền cuối kỳ của khách hàng (40=20+30)",
    assetBold: true,
    sttBold: true,
    presentBold: true,
    readOnly: true,
    valueBold: true,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 24,
    stt: "41",
    asset: "Tiền gửi ngân hàng cuối kỳ:",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 25,
    stt: "42",
    asset:
      "- Tiền gửi của Nhà đầu tư về giao dịch chứng khoán theo phương thức CTCK quản lý. Trong đó có kỳ hạn",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 26,
    stt: "43",
    asset: "- Tiền gửi tổng hợp giao dịch chứng khoán cho khách hàng",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 27,
    stt: "44",
    asset: "- Tiền gửi bù trừ và thanh toán giao dịch chứng khoán",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 28,
    stt: "45",
    asset: "- Tiền gửi của tổ chức phát hành. Trong đó có kỳ hạn",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 29,
    stt: "46",
    asset: "Các khoản tương đương tiền",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
  {
    id: 30,
    stt: "47",
    asset: "Ảnh hưởng của thay đổi tỷ giá hối đoái quy đổi ngoại tệ",
    assetBold: false,
    sttBold: false,
    presentBold: false,
    readOnly: false,
    valueBold: false,
    presentReadOnly: false,
    value: { present: "", now: 0, before: 0 },
  },
];
function Table3({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);
  const [data2, setData2] = useState(dataTable2);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data);
  };

  const handleChange2 = (values) => {
    const { id, name, value } = values;
    setData2((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value: { ...item.value, [name]: value } };
        }
        return item;
      })
    );
    console.log(data2);
  };
  return (
    <>
      <Box display="flex" flexDirection="column" mt={5}>
        <Box display="flex" justifyContent="flex-end">
          <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
            Đơn vị tiền: Đồng Việt Nam
          </Typography>
        </Box>
        <Box>
          <table style={tableStyle}>
            <thead>
              <tr>
                <Th style={{ textAlign: "center" }} rowSpan={2}>
                  Chi tiêu
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan={2}>
                  Mã số
                </Th>
                <Th style={{ textAlign: "center" }} rowSpan={2}>
                  Thuyết minh
                </Th>
                <Th style={{ textAlign: "center" }} colSpan={2}>
                  Lũy kế từ đầu năm đến cuối quý này
                </Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center" }}>Năm nay</Th>
                <Th style={{ textAlign: "center" }}>Năm trước</Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center" }}>A</Th>
                <Th style={{ textAlign: "center" }}>B</Th>
                <Th style={{ textAlign: "center" }}>C</Th>
                <Th style={{ textAlign: "center" }}>1</Th>
                <Th style={{ textAlign: "center" }}>2</Th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.length > 0 &&
                data.map((rows) => (
                  <tr key={rows.id}>
                    <Td
                      style={{
                        textAlign:
                          rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                        background: rows.readOnly === true ? "#ddeff3" : "transparent",
                        fontWeight: rows.assetBold === true ? "bold" : 400,
                      }}
                    >
                      {rows.asset}
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: rows.readOnly === true ? "#ddeff3" : "transparent",
                        fontWeight: rows.sttBold === true ? "bold" : 400,
                      }}
                    >
                      {rows.stt}
                    </Td>
                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "center",
                        background: rows.readOnly === true ? "#ddeff3" : "transparent",
                        fontWeight: rows.presentBold === true ? "bold" : 400,
                      }}
                    >
                      <InputTable2
                        id={rows.id}
                        name="present"
                        readOnly={rows.presentReadOnly}
                        value={rows.value.present}
                        onChange={handleChange}
                        fontWeight={rows.presentBold}
                      />
                    </Td>
                    {rows.valueCenter && rows.valueCenter === true ? (
                      <>
                        <Td
                          style={{
                            textAlign: "center",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          {rows.value.now}
                        </Td>
                        <Td
                          style={{
                            textAlign: "center",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          {rows.value.before}
                        </Td>
                      </>
                    ) : (
                      <>
                        <Td
                          colSpan={1}
                          style={{
                            textAlign: "right",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          <InputTable
                            id={rows.id}
                            name="now"
                            readOnly={rows.readOnly}
                            value={rows.value.now}
                            onChange={handleChange}
                            fontWeight={rows.valueBold}
                          />
                        </Td>
                        <Td
                          colSpan={1}
                          style={{
                            textAlign: "right",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          <InputTable
                            id={rows.id}
                            name="before"
                            readOnly={rows.readOnly}
                            value={rows.value.before}
                            onChange={handleChange}
                            fontWeight={rows.valueBold}
                          />
                        </Td>
                      </>
                    )}
                  </tr>
                ))}
            </tbody>
          </table>
        </Box>
        {/* <Footer formData={formData} /> */}
      </Box>
      <Box display="flex" flexDirection="column" mt={5}>
        <Box textAlign="center">
          <Typography variant="h5" textTransform="uppercase">
            Phần lưu chuyển tiền tệ hoạt động môi giới, ủy thác của khách hàng
          </Typography>
        </Box>
        <Box>
          <table style={tableStyle}>
            <thead>
              <tr>
                <Th style={{ textAlign: "center" }}>Chi tiêu</Th>
                <Th style={{ textAlign: "center" }}>Mã số</Th>
                <Th style={{ textAlign: "center" }}>Thuyết minh</Th>
                <Th style={{ textAlign: "center" }}>Năm nay</Th>
                <Th style={{ textAlign: "center" }}>Năm trước</Th>
              </tr>
              <tr>
                <Th style={{ textAlign: "center" }}>1</Th>
                <Th style={{ textAlign: "center" }}>2</Th>
                <Th style={{ textAlign: "center" }}>3</Th>
                <Th style={{ textAlign: "center" }}>4</Th>
                <Th style={{ textAlign: "center" }}>5</Th>
              </tr>
            </thead>
            <tbody>
              {data2 &&
                data2.length > 0 &&
                data2.map((rows) => (
                  <tr key={rows.id}>
                    <Td
                      style={{
                        textAlign:
                          rows.assetCenter && rows.assetCenter === true ? "center" : "left",
                        background: rows.readOnly === true ? "#ddeff3" : "transparent",
                        fontWeight: rows.assetBold === true ? "bold" : 400,
                      }}
                    >
                      {rows.asset}
                    </Td>
                    <Td
                      style={{
                        textAlign: "center",
                        background: rows.readOnly === true ? "#ddeff3" : "transparent",
                        fontWeight: rows.sttBold === true ? "bold" : 400,
                      }}
                    >
                      {rows.stt}
                    </Td>
                    <Td
                      colSpan={1}
                      style={{
                        textAlign: "center",
                        background: rows.readOnly === true ? "#ddeff3" : "transparent",
                        fontWeight: rows.presentBold === true ? "bold" : 400,
                      }}
                    >
                      <InputTable2
                        id={rows.id}
                        name="present"
                        readOnly={rows.presentReadOnly}
                        value={rows.value.present}
                        onChange={handleChange2}
                        fontWeight={rows.presentBold}
                      />
                    </Td>
                    {rows.valueCenter && rows.valueCenter === true ? (
                      <>
                        <Td
                          style={{
                            textAlign: "center",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          {rows.value.now}
                        </Td>
                        <Td
                          style={{
                            textAlign: "center",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          {rows.value.before}
                        </Td>
                      </>
                    ) : (
                      <>
                        <Td
                          colSpan={1}
                          style={{
                            textAlign: "right",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          <InputTable
                            id={rows.id}
                            name="now"
                            readOnly={rows.readOnly}
                            value={rows.value.now}
                            onChange={handleChange2}
                            fontWeight={rows.valueBold}
                          />
                        </Td>
                        <Td
                          colSpan={1}
                          style={{
                            textAlign: "right",
                            background: rows.readOnly === true ? "#ddeff3" : "transparent",
                            fontWeight: rows.readOnly === true ? "bold" : 400,
                          }}
                        >
                          <InputTable
                            id={rows.id}
                            name="before"
                            readOnly={rows.readOnly}
                            value={rows.value.before}
                            onChange={handleChange2}
                            fontWeight={rows.valueBold}
                          />
                        </Td>
                      </>
                    )}
                  </tr>
                ))}
            </tbody>
          </table>
        </Box>
        {/* <Footer formData={formData} /> */}
      </Box>
    </>
  );
}

export default memo(Table3);

function InputTable(props) {
  const { id, onChange, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
        fontWeight: fontWeight && fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function InputTable2(props) {
  const { id, onChange, type, fontWeight, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: "center",
        fontSize: "14px",
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100%",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        fontWeight: fontWeight === true ? "bold" : 400,
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
